import {tgxApi} from "../../../app/tgxApi";
import {getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess} from "../../../helpers/utils/RtkQueryUtils";
import {serialize} from "../../../helpers/utils/Utils";

export const systemPropertiesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchSystemProperties: build.query({
            query: (query) => {
                return {
                    url: `/ajax/system-properties?${serialize(query)}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["systemProperties"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getSystemPropertyById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/system-properties/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["systemPropertyById"],
            async onQueryStarted(_, {queryFulfilled}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateSystemPropertyById: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/system-properties/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ["systemPropertyById", "systemProperties"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled,"Updated" ,"System Properties")
            },
        }),

        createSystemProperty: build.mutation({
                    query: (requestBody) => {
                        return {
                            url: `/ajax/system-properties`,
                            method: 'POST',
                            headers: getAuthorizationHeader(),
                            body: requestBody
                        };
                    },
                    invalidatesTags: ['systemProperties'],
                    async onQueryStarted(_, {queryFulfilled,}) {
                        await handleQueryErrorAndSuccess(queryFulfilled, "Created", "System Property");
                    },
                }),
    })
})

export const {
    useSearchSystemPropertiesQuery,
    useGetSystemPropertyByIdQuery,
    useUpdateSystemPropertyByIdMutation,
    useCreateSystemPropertyMutation
} = systemPropertiesApi